const getDate = function (date) {
  var d = new Date(date);
  return d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
};

module.exports = getDate;



//////////////////
// WEBPACK FOOTER
// ./utils/getDate.js
// module id = 3866
// module chunks = 0